var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-artifacts",
  "use": "ring-icon-artifacts-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ring-icon-artifacts\"><path d=\"M.003 11.026v1.93l7.68 2.972a.896.896 0 0 0 .648 0l7.667-2.966v-1.93l-7.991 3.092zm0-3.98v1.931l7.68 2.972a.896.896 0 0 0 .648 0l7.667-2.967v-1.93l-7.991 3.092zM8.249.024a.647.647 0 0 0-.484 0L.015 3.145l-.012-.004v1.93l7.68 2.972a.896.896 0 0 0 .648 0l7.667-2.967V3.145zm-.242 6.215L1.965 3.901l6.042-2.469 6.068 2.457z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id